import React from 'react';
import BubblesParticlesBackground from '../ParticlesBackground/BubblesParticlesBackground';
import './About.css';
import Education from './Education';
import Experience from './Experience';
import PersonalInfo from './PersonalInfo';
import Typical from 'react-typical';
import aboutImg from '../../images/about.png';
import Skills from './Skills';

const About = () => {

    const typicalData = ['Developer', 2000, 'Programmer', 2000, 'MERN Developer', 2000];

    return (
        <>
            <div className="particles-bg">
                {/* <BubblesParticlesBackground /> */}
            </div>
            <section id="about" className="about section">
                <div className="container">
                    <div className="row">
                        <div className="section-title padd-15">
                            <h2>About Me</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="about-content padd-15">
                            <div className="row">
                                <div className="about-text padd-15">
                                    <h3>I'm S.M. Samrat and <Typical steps={typicalData} loop={Infinity} wrapper="span" /></h3>
                                    <p>I’m a passionate web developer and always pumped about learning new technologies. I never get tired or bored when I’m coding. Cause I love to Code. And I am learning and exploring more and more about this field.</p>
                                </div>
                            </div>
                            <div className="row">
                                <div data-aos="fade-up" className="about-image padd-15">
                                    <img src={aboutImg} alt="" />
                                </div>
                                <PersonalInfo></PersonalInfo>
                            </div>

                            <div className="row">
                                <Skills></Skills>
                            </div>

                            <div className="row">
                                <Education></Education>
                                <Experience></Experience>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );
};

export default About;